import { render, staticRenderFns } from "./AsEmployeePage.vue?vue&type=template&id=2dd04702&scoped=true"
import script from "./AsEmployeePage.vue?vue&type=script&lang=js"
export * from "./AsEmployeePage.vue?vue&type=script&lang=js"
import style0 from "./AsEmployeePage.vue?vue&type=style&index=0&id=2dd04702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd04702",
  null
  
)

export default component.exports